import React from 'react';
import { FlashOn, FlashOff } from '@mui/icons-material';
import { makeMetricValueString } from '../../../../../../common/services/metricUtils';
import { StatusTitle, StatusValue, StatusValues, StatusWrap } from './styles';

const statusLabelMap = {
  active: (
    <>
      <FlashOn className="icon" /> Active session
    </>
  ),
  inactive: (
    <>
      <FlashOff className="icon" /> No active session
    </>
  ),
};

function SessionStatusComponent(props) {
  const { values } = props;

  let status = 'inactive';
  let rest = {};

  if (values) {
    status = 'active';
    rest = values;
  }

  return (
    <StatusWrap>
      <StatusTitle>{statusLabelMap[status]}</StatusTitle>
      {values && (
        <StatusValues>
          {Object.keys(rest).map((key) => (
            <StatusValue key={key}>
              {makeMetricValueString(key, status === 'active' ? rest[key] : null, { dynamicDictionary: {} })}
            </StatusValue>
          ))}
        </StatusValues>
      )}
    </StatusWrap>
  );
}

export default SessionStatusComponent;
